export default "__VITE_ASSET__DsCwGZPV__"